import React, { Component, useEffect, useState } from "react"
import { EditorState, convertToRaw, ContentState, convertFromHTML } from "draft-js"
import { Editor } from "react-draft-wysiwyg"
import draftToHtml from "draftjs-to-html"

interface Props {
	value: string
	convertStringToHTML?: boolean
	resetConvertStringToHTMLValue?: () => void
	onChange: (text: any) => void
}
const toolbar = {
	// What to display
	options: ["inline", "blockType", "fontSize", "list", "textAlign", "link", "history"],

	// To customize individually and add custom icons
	inline: {
		visible: true,
		inDropdown: false,
		bold: { visible: true },
		italic: { visible: true },
		underline: { visible: true },
		strikeThrough: { visible: false },
		monospace: { visible: false },
	},
	blockType: { visible: true },
	fontSize: { visible: true },
	fontFamily: { visible: true },
	list: {
		visible: true,
		inDropdown: true,
		unordered: { visible: true },
		ordered: { visible: true },
		indent: { visible: true },
		outdent: { visible: true },
	},
	textAlign: {
		visible: true,
		inDropdown: true,
		left: { visible: true },
		center: { visible: true },
		right: { visible: true },
		justify: { visible: true },
	},
	colorPicker: { visible: true },
	link: {
		visible: true,
		inDropdown: true,
		addLink: { visible: true },
		removeLink: { visible: true },
	},
	image: {
		visible: true,
		// icon: 'xxx.png',
		fileUpload: true,
		url: true,
	},
	history: {
		visible: true,
		inDropdown: true,
		undo: { visible: true },
		redo: { visible: true },
	},
}

const RichText = ({
	value = "",
	convertStringToHTML = false,
	resetConvertStringToHTMLValue = () => {},
	onChange,
}: Props) => {
	const convertValueToDraftValue = () => {
		const blocksFromHTML = convertFromHTML(value)
		const contentState = ContentState.createFromBlockArray(
			blocksFromHTML.contentBlocks,
			blocksFromHTML.entityMap
		)
		return EditorState.createWithContent(contentState)
	}

	const [editorState, setEditorState] = useState(convertValueToDraftValue())

	// Value is converted to draft js value on mount but there are times when value is changed but component is not remounted
	useEffect(() => {
		if (convertStringToHTML) {
			setEditorState(convertValueToDraftValue())
			resetConvertStringToHTMLValue()
		}
	}, [convertStringToHTML])

	const onEditorStateChange = (editorState: EditorState) => {
		setEditorState(editorState)
		const html: string = draftToHtml(convertToRaw(editorState.getCurrentContent()))
		onChange(html)
	}

	return (
		<div className=" bg-gray-50 rounded p-2 border border-gray-200 overflow-y-auto max-h-72">
			<Editor
				editorState={editorState}
				wrapperClassName="demo-wrapper"
				editorClassName="demo-editor"
				onEditorStateChange={onEditorStateChange}
				toolbar={toolbar}
			/>
		</div>
	)
}

export default RichText
